const apiCalls = {
  loginUser: "auth/login",
  logoutUser: "auth/logout",
  loginChangePassword: "auth/loginChangePassword",
  MenuList: "menus",
  Settings: "settings",
  LocationImagePath: "uploads?uploadWhileCreate=true&uploadPath=location",
  ProfileImagePath: "uploads?uploadWhileCreate=true&uploadPath=employee",
  dashboard: "dashboard/counts",
  Uploads: "bulkuploadStatus",
  employees: "employees",
  tickets: "tickets",
  myDrives: "myDrives",
  users: "users",
  homes: "homes",
  files: "files",
  folders: "folders",
  sharedFiles: "sharedFiles",
  shareChat: 'chats/shareChatLink',
  folderUplode: "folders/uploadFolder",
  chatWithAi: 'files/chatWithAI',
  messages: 'messages',
  fileRead: 'files/fileRead',
  shareChatEmployees: 'chats/shareChat',
  summary: 'files/summarize',
  askQuestion: 'files/askQuestion',
  askQuestionFolder: 'files/askQuestionFolder',
  chats: 'chats',
  sharedChats: 'chats/shareChat',
  sharedChatUpdate: 'chats/sharedChatUpdate',
  verifyEmail: 'employees/verify-email',
  compareFiles: 'files/compareFiles',
  archive: "archive",
  trash: "trash",
  recordings: "speech",
  chatbot: "files/chatBot",
  audioFiles: 'speech/speechToText?type=audiofiles',
  clients: "clients",
  topics: "topics",
  modules: "testCasesModule",
  testCases: "testCases",
  company: "companyData",
  filesAnalysis: 'filesAnalysis',
  invoice: "invoice",
  agreement: "agreement",

  dashboardData: "views/dashboard",
  activityGraph: "views/activityGraph",
  filesGraph: 'views/filesGraph',

  agreementTemplates: "agreementTemplates",
  agreementFiles: "agreementFiles",
  uniqueCases: "cases",

  dynamicScreens:'dynamicScreens',
  smartScreens: "smartScreens",

  // Compare Workspace
  compareRun: 'compare/run',
  compareInsights: 'compare/insights',
  comparePicker: 'compare/picker',
  compareHistory: 'compare/history',
  compareRecent: 'compare/recent',
  compareSession: 'compare',
  mentionEntities: 'files/mentionEntities',
};

// {"loginUser":"auth/login","logoutUser":"auth/logout","loginChangePassword":"auth/loginChangePassword","MenuList":"menus","Settings":"settings","LocationImagePath":"uploads?uploadWhileCreate=true&uploadPath=location","ProfileImagePath":"uploads?uploadWhileCreate=true&uploadPath=employee","dashboard":"dashboard/counts","employee":"employees","employees":"employees","Uploads":"bulkuploadStatus"}

export default apiCalls;
